import { FavoritesModel } from '@/ApiTypes.ts';
import { BuildType } from '@/services/ApiService.ts';

export const favoritesApiEndpoints = (build: BuildType) => ({
    getAllFavorites: build.query<FavoritesModel, void>({
        query: () => 'favorites',
        providesTags: ['Favorites'],
    }),
});

export interface UsStateOrTerritoryModel {
    id: string;
    name: string;
    abbreviation: string;
    type: string;
    createdAt: string; // Use string for dates in frontend
    updatedAt: string;
}

export interface EducationLevelModel {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
}
